export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_FEATURE_SESSION_MANAGEMENT: import.meta.env
    .VITE_FEATURE_SESSION_MANAGEMENT,
  VITE_FEATURE_HOUSEHOLD_REDIRECT: import.meta.env
    .VITE_FEATURE_HOUSEHOLD_REDIRECT,
  // The Distribution group's apps in the app switcher (Epic GSB-8312, PO, 2026-10-27)
  VITE_BMS_URL: import.meta.env.VITE_BMS_URL,
  VITE_HOUSEHOLDS_URL: import.meta.env.VITE_HOUSEHOLDS_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
};
